export default __webpack_public_path__ + "static/Design-fbd7241ff1061e1143101e3acc503bd7.webp";